import { render, staticRenderFns } from "./data49.vue?vue&type=template&id=c792aa64&scoped=true"
import script from "./data49.vue?vue&type=script&lang=js"
export * from "./data49.vue?vue&type=script&lang=js"
import style1 from "./data49.vue?vue&type=style&index=1&id=c792aa64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c792aa64",
  null
  
)

export default component.exports